import { SECOND_MS } from "~/utils/constants";

export const INACTIVE_WARNING_DURATION = 9; // 9 seconds, duration at which the warning modal should be displayed, before closing the session
export const DEFAULT_MODAL_DURATION_MS = 5 * SECOND_MS; // 5 seconds
export const INACTIVE_WAITTIME_DURATION_MS = 20 * SECOND_MS; // 20 seconds, duration at which if the user is inactive, we show a warning modal.
